import { useState } from 'react';
import { toast } from 'react-toastify';

import { eventingApi } from '../../../../../services/eventingApi';
import { ReplayRequest } from './history';

export const useReplay = () => {
  const [request, setRequest] = useState<ReplayRequest | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const confirm = async (current: ReplayRequest, target: string) => {
    setSubmitting(true);
    try {
      const result = await eventingApi.createReplay({
        eventIds: current.events.map((event) => event.message.eventId),
        target,
        from: current.window.from,
        to: current.window.to,
      });
      const { published, failed, notFound } = result.data;
      const summary = `${published.length} replay(s) publicado(s) com target = ${target}`;
      if (failed.length || notFound.length) toast.warning(`${summary}; ${failed.length} falha(s), ${notFound.length} não encontrado(s) no histórico`);
      else toast.success(summary);
      setRequest(null);
    } catch (error) {
      toast.error((error as Error).message);
    } finally {
      setSubmitting(false);
    }
  };

  return { request, setRequest, submitting, confirm };
};
